import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const mm = gsap.matchMedia();

      $( '.inset-video-scroll-hero' ).each( function( key, component ) {
        $( this ).addClass( 'is-loaded' );

        const content = $( this ).find( '.ivsh__content' )[0];
        const link = $( this ).find( '.ivsh__content-link' )[0];
        const contentPanel = $( this ).find( '.ivsh__video-wrapper' ).parent()[0];
        const videoWrapper = $( this ).find( '.ivsh__video-wrapper' )[0];
        const overlay = $( this ).find( '.ivsh__video-overlay' )[0];
        const videoFeatures = $( this ).find( '.ivsh__video-features' )[0];
        const height = $( this ).outerHeight();
        const pinnedAmount = height * 3;
        const fake = $( this ).find( '.fake' )[0];

        let topOffset = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          topOffset += $( '#wpadminbar' ).outerHeight();
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: component,
            start: 'top ' + topOffset,
            end: '+=' + pinnedAmount,
            onUpdate: function( e ) {
              if ( e.progress > 0.5 ) {
                $( videoWrapper ).addClass( 'is-active' );
                $( contentPanel ).removeClass( 'pointer-events-none' );
              } else {
                $( videoWrapper ).removeClass( 'is-active' );
                $( contentPanel ).addClass( 'pointer-events-none' );
              }

              if ( e.progress > 0.75 ) {
                $( videoFeatures ).addClass( 'is-active' );
              } else {
                $( videoFeatures ).removeClass( 'is-active' );
              }
            },
            scrub: 1,
            // markers: true,
          },
        } );

        mm.add( '(max-width: 1023px)', () => {
          tl.fromTo(
              videoWrapper,
              {clipPath: 'inset(32px 32px 32px 32px round 9999px)'},
              {clipPath: 'inset(32px -50% 32px -50% round 9999px)', ease: 'linear', duration: 0.5},
              0,
          );
        } );

        mm.add( '(min-width: 1024px)', () => {
          tl.fromTo(
              videoWrapper,
              {clipPath: 'inset(35% 15% 35% 15% round 9999px)'},
              {clipPath: 'inset(35% -15% 35% -15% round 9999px)', ease: 'linear', duration: 0.5},
              0,
          );
        } );

        tl.fromTo(
            overlay,
            {opacity: '0'},
            {opacity: '1', ease: 'linear', duration: 1},
            0,
        );

        // Fade out content
        tl.fromTo(
            content,
            {opacity: '1', translateY: '0%'},
            {opacity: '0', translateY: '-10%', ease: 'linear', duration: 0.5},
            0,
        );

        // Fade out link
        tl.fromTo(
            link,
            {opacity: '1', translateY: '0%'},
            {opacity: '0', translateY: '10%', ease: 'linear', duration: 0.5},
            0,
        );

        mm.add( '(max-width: 1023px)', () => {
          tl.fromTo(
              videoWrapper,
              {clipPath: 'inset(32px -50% 32px -50%)'},
              {clipPath: 'inset(0% -50% 0% -50%)', ease: 'linear', delay: 0.5, duration: 0.5},
              0,
          );
        } );

        mm.add( '(min-width: 1024px)', () => {
          tl.fromTo(
              videoWrapper,
              {clipPath: 'inset(35% -15% 35% -15%)'},
              {clipPath: 'inset(0% -15% 0% -15%)', ease: 'linear', delay: 0.5, duration: 0.5},
              0,
          );
        } );

        tl.to( fake, {opacity: '0', ease: 'linear', delay: 1, duration: 0.5}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'inset-video-scroll-hero', COMPONENT );
} )( app );
